import React from 'react';
import { useNavigate } from 'react-router-dom';

export function LandingHeader() {
  const navigate = useNavigate();
  return (
    <header className="landing-header">
      <div className="header-content">
        <div className="landing-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <div className="logo-icon" style={{ fontFamily: 'monospace', fontSize: '1rem', fontWeight: 800, letterSpacing: '-0.02em' }}>
            UL
          </div>
          <div>
            <div>Uttar Labs</div>
            <div style={{ fontSize: '0.7rem', opacity: 0.85, fontWeight: 400, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
              AI & NLP Solutions · Nepal
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <a href="mailto:anzelix@gmail.com" className="header-cta" style={{ fontSize: '0.9rem', padding: '0.5rem 1.25rem' }}>
            Get in Touch
          </a>
        </div>
      </div>
    </header>
  );
}
